import axios from 'axios';
import Vue from 'vue';

const version = 'v1';
const getPublishableTokenApi = `${version}/payment/publishableToken`;

export const state = Vue.observable({});

export const mutations = {
	async getPublishableToken() {
		const result = await axios.get(getPublishableTokenApi);
		return result;
	}
}
